import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Hero from '../components/Hero/Hero'

const Main = () => {
  return (
    <div className="main_container">
        <Navbar/>
        <Hero/>
    </div>
  )
}

export default Main